import React, { Component } from 'react';
import Parser from 'html-react-parser';
import { DocumentIcon, GlobeIcon, ThumbsUpIcon, CheckmarkIcon, PackageIcon } from './SVGIcons';

import OffcanvasForm from './OffcanvasForm';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showCallForm: false,
    };
  }

  // Метод для открытия формы заказа звонка
  openCallForm = () => {
    this.setState({ showCallForm: true });
  };

  // Метод для закрытия формы заказа звонка
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем Offcanvas меню
    this.props.hide();
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {

    const data = this.props?.data || {}
    const about = data?.about_ng || {}
    const { showCallForm } = this.state

    return (
      <>
        <div className='mt-[80px] xl:mt-[100px] w-full'>
          <div className='container'>
            <div className='flex flex-col gap-[20px] xl:flex-row items-end justify-between'>
              <div>
                <div className='text-title text-ptblack uppercase tracking-tight'>{Parser(about?.title || '')}</div>
                <div className='text-base text-ptgray mt-[12px] max-w-[640px] leading-none'>
                  {Parser(about?.text || '')}
                </div>
              </div>
              <div onClick={() => this.openCallForm()} className='w-full xl:w-auto cursor-pointer bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'>
                <DocumentIcon />
                <div className='text-base'>Запросить КП</div>
              </div>
            </div>
            <div className='mt-[40px] flex-col xl:flex-row flex gap-[20px]'>
              <div className='flex-1 bg-[#F6F7F8] rounded-[14px] w-full xl:w-auto xl:min-h-[217px] gap-[60px] xl:gap-[0px] p-[20px] flex flex-col justify-between items-center'>
                <div className='flex justify-end w-full'>
                  <GlobeIcon />
                </div>
                <div className='leading-none w-full'>
                  <div className='text-cardTitle text-ptblack uppercase'>{Parser(about?.title1 || '')}</div>
                  <div className='text-ptgray text-base mt-[12px]'>
                    {Parser(about?.text1 || '')}
                  </div>
                </div>
              </div>
              <div className='flex-none bg-[#F6F7F8] rounded-[14px] w-full xl:min-h-[217px] gap-[60px] xl:gap-[0px] xl:w-[304px] p-[20px] flex flex-col justify-between items-center'>
                <div className='flex justify-end w-full'>
                  <ThumbsUpIcon />
                </div>
                <div className='leading-none w-full'>
                  <div className='text-cardTitle text-ptblack uppercase'>{Parser(about?.title2 || '')}</div>
                  <div className='text-ptgray text-base mt-[12px]'>
                    {Parser(about?.text2 || '')}
                  </div>
                </div>
              </div>
              <div
                className='flex-none bg-[#001553] rounded-[14px] w-full xl:min-h-[217px] gap-[60px] xl:gap-[0px] xl:w-[354px] p-[20px] flex flex-col justify-between items-center bg-cover bg-center'
                style={{ backgroundImage: `url('${about?.fon1}')` }}
              >
                <div className='flex justify-between items-start w-full text-white/60 text-base'>
                  <div>Опыт производства</div>
                  <CheckmarkIcon />
                </div>
                <div className='leading-none w-full'>
                  <div className='text-cardTitle text-white/60 uppercase'>основано</div>
                  <div className='text-white text-[48px]'>в 1998 году</div>
                </div>
              </div>
            </div>
            <div className='mt-[20px] flex-col xl:flex-row flex gap-[20px]'>
              <div
                className='flex-none bg-[#BC0005] rounded-[14px] w-full xl:min-h-[217px] gap-[60px] xl:gap-[0px] xl:w-[354px] p-[20px] flex flex-col justify-between items-center bg-cover bg-center'
                style={{ backgroundImage: `url('${about?.fon2}')` }}
              >
                <div className='flex justify-end items-start w-full'>
                  <img src={data?.marketImage} width={63} height={38} className='flex-none h-auto' />
                </div>
                <div className='leading-none w-full'>
                  <div className='text-cardTitle text-white uppercase'>
                    {Parser(about?.title3 || '')}
                  </div>
                  <div className='text-white/75 text-base mt-[12px]'>
                    {Parser(about?.text3 || '')}
                  </div>
                </div>
              </div>
              <div className='flex-none bg-[#F6F7F8] rounded-[14px] w-full xl:min-h-[217px] gap-[60px] xl:gap-[0px] xl:w-[304px] p-[20px] flex flex-col justify-between items-center'>
                <div className='flex justify-end w-full'>
                  <PackageIcon />
                </div>
                <div className='leading-none w-full'>
                  <div className='text-cardTitle text-ptblack uppercase'>{Parser(about?.title4 || '')}</div>
                  <div className='text-ptgray text-base mt-[12px]'>
                    {Parser(about?.text4 || '')}
                  </div>
                </div>
              </div>
              <div className='flex-1 bg-[#F6F7F8] rounded-[14px] w-full xl:w-auto xl:min-h-[217px] gap-[60px] xl:gap-[0px] p-[20px] flex flex-col justify-between items-center'>
                <div className='flex justify-end w-full'>
                  <img src={about?.image} width={112} height={38} alt='' className='h-auto' />
                </div>
                <div className='leading-none w-full'>
                  <div className='text-cardTitle text-ptblack uppercase'>{Parser(about?.title5 || '')}</div>
                  <div className='text-ptgray text-base mt-[12px]'>
                    {Parser(about?.text5 || '')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Форма заказа звонка */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle="Запросить коммерческое предложение"
          formText="Укажите контактные данные и количество — подготовим КП по выбранному товару. Если нужна доставка, добавьте адрес: рассчитаем условия и сроки под ваш регион."
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    );
  }
}

export default App;
